import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { UserProfile } from 'src/app/core/authentication/UserProfile';
import { ReferenceType } from 'src/app/shared/model/ReferenceType';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-technician-center-header',
  templateUrl: './technician-center-header.component.html',
  styleUrls: ['./technician-center-header.component.scss']
})
export class TechnicianCenterHeaderComponent implements OnInit {

  @ViewChild("anchor", { static: false })
  public anchor: ElementRef<HTMLElement>;
  
  userEmployeeProfile: UserProfile;
  showUserMenu: boolean;
  profileReferenceType:string;
  brand:string;
  isTrainingEnv:boolean;

  constructor(private authService: AuthService) {
    this.brand = environment.brand;
    this.isTrainingEnv = environment.isTrainingEnv;
  }

  ngOnInit(): void {
    this.userEmployeeProfile = this.authService.getLoggedUserInfo().getLoggedUserProfile(ReferenceType.Employee);

  }

  logoutUser(): void {
    this.authService.logout();
  }
}
